export const CHECKOUT_URL =
  'https://shop.app/checkout/62094770273/cn/hWN9kHyJlXsS2alIrbJV9vwA/en-us/shoppay?_cs=3.AMPS&_r=AQAB2OxUPl4wBBS1Sj72NAA81cgSqmm22BqrGplKzl3mUKE&authorization=MHJOTXI3b2tTTndXRk5WeWE2bmRkWnJvMXE0aUo1QVhiM2lRRE9wd21kT1RNWDVwcnVUeEs5N0J4MDg0djRTb2JveGpTaG1DRDdrQ1lUMGV0YUUxVGxpeHk1d21hekFVeDFzVU5icDJLbFdrT3NqN0EzL1RFN0ZRdG1CNXJ5aXdHTFhaTVBiWmNvWmR3TEJUZ25MU1lzdC84dGxmRkRTbnVGNy9KUDVGQTRzPS0tQnRxR2xSTis1T2R2N0M0VjJiMDZxUT09--907b4f5733c3917c34d5fe9cd2101e0b0eb02ada&preview_theme_id=132772692065&redirect_source=direct_checkout_product&tracking_unique=94a3917e-8ab3-4c09-b7fb-98f7e331802e&tracking_visit=85d79ded-2e2f-4d35-8ae2-7548c03e3b18'

// Blueprint + Escudo Espiritual (Order Bump 1)
export const CHECKOUT_URL_BUMP1 =
  'https://recursosclaros.com/cart/43752299298913:1'

// Blueprint + Buscador de Oro (Order Bump 2)
export const CHECKOUT_URL_BUMP2 =
  'https://recursosclaros.com/cart/43752299429985:1'

// Blueprint + Bump 1 + Bump 2
export const CHECKOUT_URL_BOTH =
  'https://recursosclaros.com/cart/43752300085345:1'

export function getCheckoutUrl(bump1: boolean, bump2: boolean): string {
  if (bump1 && bump2) return CHECKOUT_URL_BOTH
  if (bump1) return CHECKOUT_URL_BUMP1
  if (bump2) return CHECKOUT_URL_BUMP2
  return CHECKOUT_URL
}

export const trackAddToCart = (total: number, items: string[]) => {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', {
      content_name: items.join(' + '),
      content_type: 'product',
      value: total,
      currency: 'USD',
    })
  }
}
